import { useState } from "react";
import { Link } from "react-router-dom";
import { apiPost } from "../api/http";
import { parseApiError } from "../utils/apiErrors";
import { useAuth } from "../context/AuthContext";
import HealthStatus from "./HealthStatus";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isAuthenticated } = useAuth();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [subscribing, setSubscribing] = useState(false);
  const [subscribeMessage, setSubscribeMessage] = useState("");

  const handleSubscribe = async (event) => {
    event.preventDefault();
    if (!email.trim()) return;
    setSubscribing(true);
    setSubscribeMessage("");
    try {
      await apiPost("/api/newsletter/subscribe", {
        email: email.trim(),
        source: "homepage",
      });
      setSubscribed(true);
      setSubscribeMessage("Thanks! Please check your email to confirm your subscription.");
      setEmail("");
    } catch (err) {
      setSubscribed(false);
      setSubscribeMessage(parseApiError(err, "Unable to subscribe right now."));
    } finally {
      setSubscribing(false);
    }
  };

  if (isAuthenticated) {
    return (
      <footer className="footer-dashboard">
        <div className="footer-dashboard-content">
          <div>
            &copy; {currentYear} Nova SEO. All rights reserved.
          </div>
          <div className="footer-dashboard-links">
            <Link to="/privacy">Privacy Policy</Link>
            <a href="/terms">Terms of Service</a>
            <a href="#cookies">Cookie Policy</a>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <HealthStatus footerMode />
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <div className="footer-logo">
              <img src="/logo.svg" alt="Nova SEO Logo" style={{ height: "32px", width: "32px", borderRadius: "8px", objectFit: "contain" }} />
              <span className="footer-logo-text">Nova SEO</span>
            </div>
            <p className="footer-description">
              Professional SEO analysis and optimization tools for your website's success.
            </p>
            <div className="footer-socials">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" title="Twitter" className="social-link">
                𝕏
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" title="GitHub" className="social-link">
                ⚙️
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" title="LinkedIn" className="social-link">
                💼
              </a>
            </div>
            <form className="footer-subscribe" onSubmit={handleSubscribe}>
              <label htmlFor="footer-subscribe-email" className="footer-subscribe-label">
                Subscribe for product updates
              </label>
              <div className="footer-subscribe-row">
                <input
                  id="footer-subscribe-email"
                  type="email"
                  value={email}
                  onChange={(event) => {
                    setSubscribed(false);
                    setEmail(event.target.value);
                  }}
                  placeholder="you@example.com"
                  className="footer-subscribe-input"
                  required
                />
                <button type="submit" className="footer-subscribe-btn">
                  {subscribing ? "Subscribing..." : "Subscribe"}
                </button>
              </div>
              {subscribeMessage ? (
                <div className={`footer-subscribe-note ${subscribed ? "success" : "error"}`}>
                  {subscribeMessage}
                </div>
              ) : null}
            </form>
          </div>

          {/* Product Links */}
          <div className="footer-section">
            <h4 className="footer-title">Product</h4>
            <ul className="footer-links">
              <li><Link to="/audit">SEO Audit</Link></li>
              <li><Link to="/pagespeed">PageSpeed</Link></li>
              <li><Link to="/keywords">Keyword Research</Link></li>
              <li><Link to="/broken-links">Broken Links</Link></li>
            </ul>
          </div>

          {/* Company Links */}
          <div className="footer-section">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="/docs">Documentation</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h4 className="footer-title">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><a href="/terms">Terms of Service</a></li>
              <li><a href="#cookies">Cookie Policy</a></li>
              <li><a href="#sitemap">Sitemap</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p className="footer-copyright">
              &copy; {currentYear} Nova SEO. All rights reserved.
            </p>
          </div>

          <div className="footer-bottom-center">
            {/* footerMode: dot + "Live" + HH:MM, no refresh button */}
            <HealthStatus footerMode />
          </div>

          <div className="footer-bottom-right">
            <p className="footer-status">Built with ❤️ for SEO professionals</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;